function changeSearchRoutesForB2B() {
    const searchForms = document.querySelectorAll(".main-search__form, .main-search__form_head");
    let changed = false;
    if (document.body.classList.contains("is-b2b")) {
      searchForms.forEach((form) => {
        const input = form.querySelector(".main-search__input");
        // Only proceed if Searchanise has finished (input has .snize-input-style)
        if (input && input.classList.contains("snize-input-style")) {
          if (form.action.includes("/pages/search-results-page")) {
            form.action = "/search";
            changed = true;
          }
        }
  
        // Clone the form and add it to a new .main-search__container if not already present
        // if (!form.closest(".main-search__container")) {
        //   const clonedForm = form.cloneNode(true);
        //   const container = document.createElement("div");
        //   container.className = "main-search__container";
        //   container.appendChild(clonedForm);
        //   form.parentNode.parentNode.insertBefore(container, form.parentNode.nextSibling);
        //   // Optionally, remove the original form if needed:
        //   form.parentNode.removeChild(form);
  
        //   form.addEventListener("submit", (e) => {
        //     e.preventDefault();
        //     // const query = input.value;
        //     console.log("Redirecting to /search with query:", query);
        //     // if (query && query.trim().length > 0) {
        //     // window.location.href = `/search?q=${encodeURIComponent(query.trim())}`;
        //     // }
        //   });
        // }
      });
    }
    return changed;
  }
  
  function closeSearchaniseOverlay() {
    document.querySelectorAll("input.snize-input-style, input.main-search__input").forEach(function (input) {
      input.value = "";
      input.dispatchEvent(new Event("input", { bubbles: true }));
    });

    const $ = window.Searchanise && window.Searchanise.$;
    if ($) {
      $("input.snize-input-style, input.main-search__input").val("").trigger("input").trigger("keyup");
    }

    document.querySelectorAll(".snize-ac-results.snize-new-design").forEach(function (results) {
      results.style.display = "none";
    });

    document.body.classList.remove("snize-instant-widget-is-open");
  }

  function initSnizeCloseButton() {
    document.addEventListener("click", function (e) {
      if (!e.target.closest(".snize-dropdown-arrow")) return;
      e.preventDefault();
      closeSearchaniseOverlay();
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    var interval = setInterval(() => {
      if (changeSearchRoutesForB2B()) {
        clearInterval(interval);
      }
    }, 500);
    initSnizeCloseButton();
  });